import React, { FunctionComponent, PropsWithChildren } from 'react'
import { CardContent, Grid, Divider } from '@material-ui/core'
import { ContainerCards, Content, StyledCard, Title, Footer } from './styles'

interface ConteudoPagamentosProp extends PropsWithChildren<any> {
  title: string
  titleColor?: string
  justifyContent?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline'
  alignContent?:
    | 'stretch'
    | 'center'
    | 'flex-start'
    | 'flex-end'
    | 'space-between'
    | 'space-around'
  alignItems?: 'flex-start' | 'center' | 'flex-end' | 'stretch' | 'baseline'
  footer?: React.ReactElement
}
const ConteudoPagamentos: FunctionComponent<ConteudoPagamentosProp> = ({
  title,
  titleColor,
  justifyContent,
  alignItems,
  alignContent,
  children,
  footer,
}) => {
  return (
    <>
      <ContainerCards>
        <Grid container spacing={2}>
          <Grid item sm={12}>
            <StyledCard
              variant={'outlined'}
              style={{
                borderRadius: 8,
              }}
            >
              <CardContent>
                <Grid container spacing={2}>
                  <Grid
                    item
                    sm={12}
                    style={{
                      padding: 10,
                      paddingLeft: 18,
                    }}
                  >
                    <Title
                      style={{
                        fontWeight: 600,
                        color: titleColor,
                      }}
                    >
                      {title}
                    </Title>
                  </Grid>
                  <Grid item sm={12}>
                    <Divider />
                  </Grid>
                  <Content
                    alignContent={alignContent}
                    alignItems={alignItems}
                    justifyContent={justifyContent}
                  >
                    {children}
                  </Content>
                </Grid>
              </CardContent>

              {footer && (
                <Grid container spacing={2}>
                  <Grid item sm={12}>
                    <Divider />
                  </Grid>
                  <Grid item sm={12}>
                    <Footer>{footer}</Footer>
                  </Grid>
                </Grid>
              )}
            </StyledCard>
          </Grid>
        </Grid>
      </ContainerCards>
    </>
  )
}

export default ConteudoPagamentos
